// noinspection SpellCheckingInspection

import airsoftBadges from '@/constants/airsoftBadges';

export default [
  {
    firstName: 'Nick N.',
    title: 'W2-1',
    tag: 'NJ',
    image: '/assets/branches/airsoft/members/nick-nickels.png',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=113385',
    joinYear: 2018,
    badges: [
      airsoftBadges.THUNDERSTRIKE3,
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.OPERATION_RISENFALL_LIGHTSIM,
      airsoftBadges.DARK_EMERGENCY_12,
      airsoftBadges.DARK_EMERGENCY_11,
      airsoftBadges.DARK_EMERGENCY_10,
      airsoftBadges.DARK_EMERGENCY_9,
      airsoftBadges.MISSION_24H,
      airsoftBadges.OPERATION_SOURCE_LIGHTSIM,
      airsoftBadges.FOUNDATION_MEMBER,
    ]
  },
  {
    firstName: 'Jan A.',
    title: 'Teamleiter | W1-1',
    tag: 'Jerky',
    image: '/assets/branches/airsoft/members/jerky.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=100900',
    joinYear: 2022,
    badges: [
      airsoftBadges.THUNDERSTRIKE3,
      airsoftBadges.OPERATION_TITAN_LIGHTSIM,
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.OPERATION_RISENFALL_LIGHTSIM,
      airsoftBadges.DARK_EMERGENCY_12,
    ]
  },
  {
    firstName: 'Simon B.',
    title: 'Operator',
    tag: null,
    image: '/assets/branches/airsoft/members/simon.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=151084',
    joinYear: 2022,
    badges: []
  },
  {
    firstName: 'Moritz K.',
    title: 'Operator | W1-2',
    tag: 'Porter',
    image: '/assets/branches/airsoft/members/moritz.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=94617',
    joinYear: 2022,
    badges: [
      airsoftBadges.THUNDERSTRIKE3,
      airsoftBadges.MISSION_24H_2025,
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.OPERATION_RISENFALL_LIGHTSIM,
      airsoftBadges.DARK_EMERGENCY_12,
      airsoftBadges.DARK_EMERGENCY_11,
    ]
  },
  {
    firstName: 'Ulli W.',
    title: 'Spielfeldbeauftragter | Stv. Teamleiter',
    tag: 'DogByte',
    image: '/assets/branches/airsoft/members/dogbyte.png',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=190668',
    joinYear: 2023,
    badges: [
      airsoftBadges.THUNDERSTRIKE3,
      airsoftBadges.OPERATION_TITAN_LIGHTSIM,
      airsoftBadges.MISSION_24H_2025,
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.OPERATION_RISENFALL_LIGHTSIM,
      airsoftBadges.DARK_EMERGENCY_12,
    ]
  },
  {
    firstName: 'Paul K.',
    title: 'Operator | W1-4',
    tag: 'Aqua',
    image: '/assets/branches/airsoft/members/paul.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=158334',
    joinYear: 2021,
    badges: [
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.OPERATION_RISENFALL_LIGHTSIM,
      airsoftBadges.DARK_EMERGENCY_12,
      airsoftBadges.DARK_EMERGENCY_10
    ]
  },
  {
    firstName: 'Philipp G.',
    title: 'Operator | W2-2',
    tag: 'Flipper',
    image: '/assets/branches/airsoft/members/philipp.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=112370',
    joinYear: 2018,
    badges: [
      airsoftBadges.FOUNDATION_MEMBER,
    ]
  },
  {
    firstName: 'Malte S.',
    title: 'Operator | W2-3',
    tag: null,
    image: '/assets/branches/airsoft/members/malte.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=68868',
    joinYear: 2022,
    badges: [
      airsoftBadges.OPERATION_RISENFALL_LIGHTSIM,
      airsoftBadges.OPERATION_SOURCE_LIGHTSIM,
    ]
  },
  {
    firstName: 'Leif L.',
    title: 'Operator | W2-4',
    tag: 'Blaubär',
    image: '/assets/branches/airsoft/members/leif-blaubaer.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=142265',
    joinYear: 2018,
    badges: [
      airsoftBadges.THUNDERSTRIKE3,
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.OPERATION_RISENFALL_LIGHTSIM,
      airsoftBadges.DARK_EMERGENCY_12,
      airsoftBadges.DARK_EMERGENCY_11,
      airsoftBadges.DARK_EMERGENCY_10,
      airsoftBadges.DARK_EMERGENCY_9,
      airsoftBadges.FOUNDATION_MEMBER,
    ]
  },
  {
    firstName: 'Oliver W.',
    title: 'Operator',
    tag: 'Brinick',
    image: '/assets/branches/airsoft/members/oliver.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=153898',
    joinYear: 2018,
    badges: [
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.DARK_EMERGENCY_11,
      airsoftBadges.DARK_EMERGENCY_10,
      airsoftBadges.MISSION_24H,
      airsoftBadges.OP
    ]
  },
  {
    firstName: 'Jerome G.',
    title: 'Operator | P1-1',
    tag: 'Maverick',
    image: '/assets/branches/airsoft/members/jerome.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=161569',
    joinYear: 2018,
    badges: [
      airsoftBadges.DARK_EMERGENCY_12,
    ]
  },
  {
    firstName: 'Tim M.',
    title: 'Operator',
    tag: 'Kolibri',
    image: '/assets/branches/airsoft/members/tim-maetzig.png',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=156296',
    joinYear: 2022,
    badges: [
      airsoftBadges.TCHERNO_2025,
      airsoftBadges.OPERATION_TITAN_LIGHTSIM,
      airsoftBadges.MISSION_24H_2025,
      airsoftBadges.STORMTIDE_2025,
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.DARK_EMERGENCY_10
    ]
  },
  {
    firstName: 'Sercan C.',
    title: 'Operator',
    tag: 'Doc',
    image: '/assets/branches/airsoft/members/sercan.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=173016',
    joinYear: 2022,
    badges: [
      airsoftBadges.DARK_EMERGENCY_11,
      airsoftBadges.DARK_EMERGENCY_10,
      airsoftBadges.MISSION_24H,
      airsoftBadges.OP
    ]
  },
  {
    firstName: 'Nick P.',
    title: 'Operator',
    tag: null,
    image: '/assets/branches/airsoft/members/nick-desastermon.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=173262',
    joinYear: 2022,
    badges: []
  },
  {
    firstName: 'Eric L.',
    title: 'Operator',
    tag: null,
    image: '/assets/branches/airsoft/members/eric-linau.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=173346',
    joinYear: 2022,
    badges: [
      airsoftBadges.DARK_EMERGENCY_11,
    ]
  },
  {
    firstName: 'Tamino L.',
    title: 'U18 Betreuer',
    tag: null,
    image: '/assets/branches/airsoft/members/tamino.png',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=173634',
    joinYear: 2022,
    badges: [
      airsoftBadges.THUNDERSTRIKE3,
    ]
  },
  {
    firstName: 'Niklas S.',
    title: 'Operator',
    tag: null,
    image: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=174983',
    joinYear: 2022,
    badges: []
  },
  {
    firstName: 'Björn T.',
    title: 'Operator',
    tag: null,
    image: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=149255',
    joinYear: 2020,
    badges: []
  },
  {
    firstName: 'Marten W.',
    title: 'Operator',
    tag: null,
    image: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=82775',
    joinYear: 2022,
    badges: []
  },
  {
    firstName: 'Richard S.',
    title: 'Operator',
    tag: null,
    image: '/assets/branches/airsoft/members/richard.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=140892',
    joinYear: 2019,
    badges: [
      airsoftBadges.DARK_EMERGENCY_11,
      airsoftBadges.DARK_EMERGENCY_10,
      airsoftBadges.DARK_EMERGENCY_9,
      airsoftBadges.FOUNDATION_MEMBER,
    ]
  },
  {
    firstName: 'Garvin H.',
    title: 'Operator',
    tag: 'Winny',
    image: '/assets/branches/airsoft/members/garvin.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=142173',
    joinYear: 2018,
    badges: [
      airsoftBadges.DARK_EMERGENCY_9,
      airsoftBadges.FOUNDATION_MEMBER,
    ]
  },
  {
    firstName: 'Janik B.',
    title: 'Operator',
    tag: null,
    image: '/assets/branches/airsoft/members/janik.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=143939',
    joinYear: 2020,
    badges: [
      airsoftBadges.FOUNDATION_MEMBER,
    ]
  },
  {
    firstName: 'Jan-Niklas R.',
    title: 'Operator | P1-3',
    tag: null,
    image: '/assets/branches/airsoft/members/jan-niklas.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=172653',
    joinYear: 2022,
    badges: [
      airsoftBadges.DARK_EMERGENCY_12,
    ]
  },
  {
    firstName: 'Willi H.',
    title: 'Operator',
    tag: null,
    image: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=141537',
    joinYear: 2019,
    badges: [
      airsoftBadges.DARK_EMERGENCY_11,
      airsoftBadges.DARK_EMERGENCY_10,
      airsoftBadges.FOUNDATION_MEMBER,
    ]
  },
  {
    firstName: 'Thies G.',
    title: 'Operator',
    tag: null,
    image: '/assets/branches/airsoft/members/thies.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=99801',
    joinYear: 2022,
    badges: [
      airsoftBadges.DARK_EMERGENCY_11,
      airsoftBadges.OPERATION_SOURCE_LIGHTSIM,
    ]
  },
  {
    firstName: 'Stefan B.',
    title: 'Operator',
    tag: null,
    image: '/assets/branches/airsoft/members/stefan.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=team&teamnummer=011712',
    joinYear: 2022,
    badges: []
  },
  {
    firstName: 'Leon G.',
    title: 'Operator',
    tag: null,
    image: '/assets/branches/airsoft/members/leon.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=177464',
    joinYear: 2022,
    badges: [
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.DARK_EMERGENCY_11,
      airsoftBadges.MISSION_24H
    ]
  },
  {
    firstName: 'Nico D.',
    title: 'Operator',
    tag: null,
    image: null,
    link: null,
    joinYear: 2023,
    badges: []
  },
  {
    firstName: 'Niklas H.',
    title: 'Operator',
    tag: 'Harburg',
    image: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=180690',
    joinYear: 2023,
    badges: []
  },
  {
    firstName: 'Thorben S.',
    title: 'Operator | P1-4',
    tag: null,
    image: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=164256',
    joinYear: 2023,
    badges: [
      airsoftBadges.DARK_EMERGENCY_12,
    ]
  },
  {
    firstName: 'Tizio C.',
    title: 'Operator',
    tag: null,
    image: '/assets/branches/airsoft/members/tizio.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=175929',
    joinYear: 2023,
    badges: [
      airsoftBadges.OPERATION_TITAN_LIGHTSIM,
      airsoftBadges.DARK_EMERGENCY_13
    ]
  },
  {
    firstName: 'Luca S.',
    title: 'Operator',
    tag: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=187568',
    joinYear: 2023,
    image: null,
    badges: []
  },
  {
    firstName: 'Jan L.',
    title: 'Operator',
    tag: null,
    image: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=174947',
    joinYear: 2023,
    badges: [
      airsoftBadges.THUNDERSTRIKE3,
      airsoftBadges.DARK_EMERGENCY_13
    ]
  },
  {
    firstName: 'Leon V.',
    title: 'Operator',
    tag: null,
    image: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=121666',
    joinYear: 2023,
    badges: [
      airsoftBadges.DARK_EMERGENCY_13
    ]
  },
  {
    firstName: 'Benjamin G.',
    title: 'Operator',
    tag: 'Rhino',
    image: null,
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=203287',
    joinYear: 2024,
    badges: [
      airsoftBadges.OPERATION_TITAN_LIGHTSIM,
    ]
  },
  {
    firstName: 'Michael K.',
    title: 'Stellv. Spielfeldbeauftragter',
    tag: 'Hardstyle',
    image: '/assets/branches/airsoft/members/michael.png',
    link: null,
    joinYear: 2024,
    badges: [
      airsoftBadges.THUNDERSTRIKE3,
      airsoftBadges.OPERATION_TITAN_LIGHTSIM,
      airsoftBadges.MISSION_24H_2025,
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.OPERATION_RISENFALL_LIGHTSIM
    ]
  },
  {
    firstName: 'Fabio M.',
    title: 'Operator',
    tag: 'SadBoy',
    image: null,
    link: null,
    joinYear: 2024,
    badges: []
  },
  {
    firstName: 'Christopher V.',
    title: 'Social Media | P1-2',
    tag: 'Bird',
    image: '/assets/branches/airsoft/members/christopher.jpg',
    link: null,
    joinYear: 2024,
    badges: [
      airsoftBadges.DARK_EMERGENCY_13,
      airsoftBadges.DARK_EMERGENCY_12
    ]
  },
  {
    firstName: 'Niklas R.',
    title: 'Operator',
    tag: 'Bert',
    image: null,
    link: null,
    joinYear: 2024,
    badges: []
  },
  {
    firstName: 'Niklas M.',
    title: 'Operator',
    tag: 'Sillo',
    image: '/assets/branches/airsoft/members/sillo.jpg',
    link: null,
    joinYear: 2024,
    badges: [
      airsoftBadges.OPERATION_TITAN_LIGHTSIM,
      airsoftBadges.MISSION_24H_2025,
      airsoftBadges.OPERATION_RISENFALL_LIGHTSIM
    ]
  },
  {
    firstName: 'Philipp K.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2024,
    badges: []
  },
  {
    firstName: 'Philip S.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2024,
    badges: []
  },
  {
    firstName: 'Jonas W.',
    title: 'Operator',
    tag: '',
    image: '/assets/branches/airsoft/members/jonas.png',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=175928',
    joinYear: 2024,
    badges: [
      airsoftBadges.THUNDERSTRIKE3,
      airsoftBadges.OPERATION_TITAN_LIGHTSIM,
      airsoftBadges.DARK_EMERGENCY_13
    ]
  },
  {
    firstName: 'Manuel J.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2024,
    badges: []
  },
  {
    firstName: 'Ole C.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2024,
    badges: [
      airsoftBadges.DARK_EMERGENCY_13
    ]
  },
  {
    firstName: 'Cedrik R.',
    title: 'Operator',
    tag: 'Ernie',
    image: null,
    link: null,
    joinYear: 2024,
    badges: [
      airsoftBadges.DARK_EMERGENCY_13
    ]
  },
  {
    firstName: 'Julian E.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2024,
    badges: []
  },
  {
    firstName: 'Andreas R.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2024,
    badges: []
  },
  {
    firstName: 'Marvin S.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2024,
    badges: [
      airsoftBadges.OPERATION_TITAN_LIGHTSIM,
    ]
  },
  {
    firstName: 'Leon F.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2024,
    badges: [
      airsoftBadges.DARK_EMERGENCY_13
    ]
  },
  {
    firstName: 'Mike S.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2024,
    badges: []
  },
  {
    firstName: 'Niklas J.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2025,
    badges: []
  },
  {
    firstName: 'Robert H.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2025,
    badges: []
  },
  {
    firstName: 'Marius S.',
    title: 'Operator',
    tag: '',
    image: null,
    link: null,
    joinYear: 2025,
    badges: []
  },
  {
    firstName: 'Sascha R.',
    title: 'Operator',
    tag: 'Samapari',
    image: '/assets/branches/airsoft/members/sascha.png',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=214170',
    joinYear: 2025,
    badges: []
  },
  {
    firstName: 'Timo B.',
    title: 'Operator',
    tag: 'Böcky',
    image: '/assets/branches/airsoft/members/boecki.jpg',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=214744',
    joinYear: 2025,
    badges: []
  },
  {
    firstName: 'Robert T.',
    title: 'Operator',
    tag: 'El Flame',
    image: '/assets/branches/airsoft/members/robert.png',
    link: 'https://www.airsoft-verzeichnis.de/index.php?status=mitglied&nummer=220436',
    joinYear: 2025,
    badges: []
  }
];
